<template>
  <v-dialog
    v-model="dialogCommentary"
    transition="dialog-top-transition"
    persistent
    :scrollable="false"
    :scroll-strategy="'none'"
    max-width="450px"
  >
    <v-card class="pa-4">
      <div class="wrapper">
        <!-- EXIT BUTTON -->
        <v-row dense class="justify-end">
          <v-col cols="auto">
            <ExitButton @click="dialogCommentary = false" />
          </v-col>
        </v-row>

        <!-- TITLE -->
        <v-row class="justify-center mt-n10">
          <v-col cols="auto">
            <v-card-title>{{ dialogCommentarySeat.description }}</v-card-title>
          </v-col>
        </v-row>

        <!-- SUBTITLE -->
        <v-row class="justify-center mt-n6">
          <v-col cols="auto">
            <v-card-subtitle>
              {{ dialogCommentarySeat.room + ', Platz ' + dialogCommentarySeat.name }}
            </v-card-subtitle>
          </v-col>
        </v-row>

        <!-- COMMENT FIELD -->
        <v-row class="justify-center mt-4">
          <v-col cols="10">
            <v-textarea
              :model-value="commentary"
              label="Kommentar"
              prepend-inner-icon="mdi-message"
              variant="solo"
              readonly
              auto-grow
            />
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ExitButton from '../consumables/ExitButton.vue';

export default {
  components: { ExitButton },

  props: {
    dialogCommentarySeat: { type: Object, default: null },
    commentary: { type: String, required: true },
  },

  data() {
    return {
      dialogCommentary: false
    }
  },

  methods: {
    openDialogCommentary() {
      this.dialogCommentary = true
    }
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 8px !important;
}
@media (max-width: 600px) {
    .v-card {
        transform: scale(0.5);
        transform-origin: center;
    }
    .v-textarea {
      transform: scale(0.75);
      transform-origin: top;
    }
}
</style>